export const Props = () => ({
  //Список сигналов
  signals: {
    type: [Array, null],
    required: true,
  }
});